import { render, staticRenderFns } from "./DictionariesEditing.vue?vue&type=template&id=189845a8&scoped=true&"
import script from "./DictionariesEditing.vue?vue&type=script&lang=js&"
export * from "./DictionariesEditing.vue?vue&type=script&lang=js&"
import style0 from "./DictionariesEditing.vue?vue&type=style&index=0&id=189845a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189845a8",
  null
  
)

export default component.exports